export const accentClasses = [
    'accent-color-0',
    'accent-color-1',
    'accent-color-2',
    'accent-color-3',
    'accent-color-4',
];

export function getTagAccentNumber(string) {
    return string ? string.split('').map(x => x.charCodeAt(0))
        .reduce((acc, num) => {
            acc += num;
            return acc;
        }, 0) % 5 : 0;
}